<template>
	<div class="child_login_mask">
		<div class="child_mask_mask" @click="colse" ></div>
		<div class="child_login">
			<img src="../../../assets/images/login/login_icon.png" class="child_login_img" alt="大有空间">
			<van-cell-group class="child_login_input flex" inset>
				<van-field v-model="phone" type="tel" maxlength="11" placeholder="请输入手机号" />
			</van-cell-group>

			<van-cell-group class="child_login_input flex" :class="{'child_login_zero':!status}" inset>
				<van-field v-model="code" maxlength="6" type="tel" placeholder="输入验证码" />
				<button class="child_login_code_box flex" @click="get_code()" >
					<div class="flex child_login_code">
                        {{hint}}
                    </div>
				</button>
			</van-cell-group>
			<div class="child_login_hint">我已阅读并同意<em @click="agreement('agreementfive')" >《用户协议》</em>与<em @click="agreement('privacyfive')" >《隐私政策》</em></div>
			<button class="flex child_login_buttom" @click="login">{{title}}</button>
			<div class="flex child_login_err" v-if="!phone_status" >
				<div class="child_login_err_img"><img src="../../../assets/images/login/login_err.png" alt=""></div>
				手机号格式不正确
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Field
	} from 'vant';
	Vue.use(Field);
	import { getVerifyCode } from '@/api/login'
    import { promote_login } from '@/api/invitation';
	export default {
		data() {
			return {
				phone: "",
				code: "",
				status: false,
				phone_status: true,
				hint:"获取验证码",
				timer:"",
				remaining:60,
			}
		},
		props: {
			title: {
				type: String,
				value: ""
			},
			wx_code: {
				type: String,
			},
		},
		watch: {
			phone(val) {
				let regExp = new RegExp('^1[3578]\\d{9}$')
				//如果手机号输入正确 解锁验证码
				if (val && regExp.test(val)) {
					this.status = true
					this.phone_status = true
					return
				}
				//如果手机号输入11位 报错提示
				if (val.length == 11 && !regExp.test(val)) return this.phone_status = false
			}
		},
		methods: {
            // 校验手机号
            verify_mobile () {
                const val = this.phone;
                if (!val) return false;
                if (val.length !== 11) return false;

                const myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
                if (!myreg.test(val)) return false;

                return true;
            },
            // 校验验证码
            verify_code () {
                const val = this.code;
                if (!val) return false;
                if (val.length !== 6) return false;

                return true;
            },
			agreement(name){
				this.$router.push({
					name,
					query:{t:new Date().getTime()}
				})
			},
			login() {//登录信息
                if (!this.verify_mobile()) {
                    return this.$toast({
                        type: 'fail',
                        message: '手机号有误',
                    })
                    
                }
                if (!this.verify_code()) {
                    return this.$toast({
                        type: 'fail',
                        message: '验证码有误',
                    })
                }

                promote_login({
                    phone: this.phone,
                    sms_code: this.code,
                    wx_code: this.wx_code,
                    vip_code: this.$route.query.vip_code,
                }).then(res=>{
                    // res= res.data
                    localStorage.setItem('token',`Bearer ${res.login_token}`)
                    localStorage.setItem('checkin_status', res.checkin_status) // 普通预约状态0未约1已约
                    localStorage.setItem('vip_checkin_status', res.vip_checkin_status) // vip领取状态0未领1已领
                    this.$emit('login', true)
                })
			},
			colse(){//关闭
				this.$emit('login',false)
			},
			//获取验证码
			get_code(){
				if(this.remaining!=60||!this.phone_status&&this.phone.length==11) return 
				//验证码邀请
				getVerifyCode({phone:this.phone}).then(()=>{
					this.$toast('验证码发送成功')
				})
				const fn = ()=>{
					if(this.remaining){
						this.remaining--
						this.hint=`${this.remaining}S`
					}else{
						clearInterval(this.timer)
						this.hint='重新获取'
						return this.remaining = 0
					}
				}
				
				this.timer = setInterval(fn,1000)
				
			},
			
		}
	}
</script>

<style scoped>
	@import './login.scss';
</style>
